import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaSave, FaTrash, FaPlus } from 'react-icons/fa';
import { usePortfolio } from '../../context/PortfolioContext';

const FooterSettings = () => {
  const { portfolioData, updateFooter } = usePortfolio();
  const [formData, setFormData] = useState({
    name: 'Dhiraj TH',
    title: 'AI Engineer & Innovator',
    email: 'contactdhirajth@gmail.com',
    links: {
      github: 'https://github.com/dhiraj-th',
      linkedin: 'https://linkedin.com/in/dhiraj-th',
      youtube: 'https://youtube.com/@dhiraj-th'
    },
    quickLinks: [
      { name: 'Home', href: '#home' },
      { name: 'About', href: '#about' },
      { name: 'Work', href: '#work' },
      { name: 'Collaborate', href: '#collaborate' }
    ]
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (portfolioData?.footer) {
      setFormData({
        ...portfolioData.footer,
        quickLinks: portfolioData.footer.quickLinks || [],
        links: portfolioData.footer.links || { github: '', linkedin: '', youtube: '' }
      });
    }
  }, [portfolioData?.footer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLinkChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      links: {
        ...prev.links,
        [name]: value
      }
    }));
  };

  const handleQuickLinkChange = (index, field, value) => {
    const updatedLinks = [...formData.quickLinks];
    updatedLinks[index] = {
      ...updatedLinks[index],
      [field]: value
    };
    
    setFormData(prev => ({
      ...prev,
      quickLinks: updatedLinks
    }));
  };

  const addQuickLink = () => {
    setFormData(prev => ({
      ...prev,
      quickLinks: [
        ...prev.quickLinks,
        { name: 'New Link', href: '#' }
      ]
    }));
  };

  const removeQuickLink = (index) => {
    const updatedLinks = [...formData.quickLinks];
    updatedLinks.splice(index, 1);
    
    setFormData(prev => ({
      ...prev,
      quickLinks: updatedLinks
    }));
  };

  const handleSubmit = async () => {
    setMessage('');
    const res = await updateFooter(formData);
    if (res.success) {
      setMessage('Footer updated successfully!');
    } else {
      setMessage(res.error || 'Failed to update footer');
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold mb-6 pb-2 border-b border-gray-700">Footer Settings</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-gray-300 mb-2">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
          />
        </div>
        
        <div>
          <label className="block text-gray-300 mb-2">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
          />
        </div>
        
        <div>
          <label className="block text-gray-300 mb-2">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
          />
        </div>
      </div>
      
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-white">Social Links</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-gray-300 mb-2">GitHub</label>
            <input
              type="url"
              name="github"
              value={formData.links.github}
              onChange={handleLinkChange}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
            />
          </div>
          
          <div>
            <label className="block text-gray-300 mb-2">LinkedIn</label>
            <input
              type="url"
              name="linkedin"
              value={formData.links.linkedin}
              onChange={handleLinkChange}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
            />
          </div>
          
          <div>
            <label className="block text-gray-300 mb-2">YouTube</label>
            <input
              type="url"
              name="youtube"
              value={formData.links.youtube}
              onChange={handleLinkChange}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
            />
          </div>
        </div>
      </div>
      
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold text-white">Quick Links</h3>
          <motion.button
            type="button"
            onClick={addQuickLink}
            className="bg-primary/80 hover:bg-primary text-white p-2 rounded-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaPlus />
          </motion.button>
        </div>
        
        <div className="space-y-4">
          {(formData.quickLinks || []).map((link, index) => (
            <div key={index} className="flex items-center gap-4">
              <div className="flex-1">
                <input
                  type="text"
                  value={link.name}
                  onChange={(e) => handleQuickLinkChange(index, 'name', e.target.value)}
                  className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
                  placeholder="Link Name"
                />
              </div>
              
              <div className="flex-1">
                <input
                  type="text"
                  value={link.href}
                  onChange={(e) => handleQuickLinkChange(index, 'href', e.target.value)}
                  className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
                  placeholder="Link URL or #anchor"
                />
              </div>
              
              <motion.button
                type="button"
                onClick={() => removeQuickLink(index)}
                className="bg-red-600 hover:bg-red-700 text-white p-2 rounded-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaTrash />
              </motion.button>
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex justify-end">
        <motion.button
          type="button"
          onClick={handleSubmit}
          className="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg flex items-center gap-2"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaSave /> Save Footer Changes
        </motion.button>
      </div>
      {message && <div className={`mt-4 text-sm ${message.includes('success') ? 'text-green-400' : 'text-red-400'}`}>{message}</div>}
    </div>
  );
};

export default FooterSettings; 